import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductDto } from 'src/app/model/ProductDto';
import { BugGravities } from 'src/app/model/ProjectBugReleases';
import { MatDialog } from '@angular/material/dialog';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { PaiIncident, PaiIncidentRow } from 'src/app/model/PaiIncident';
import { IncidentDetailsComponent } from '../incident-details/incident-details.component';
import { ReportsService } from 'src/app/core/services/reports.service';

@Component({
  selector: 'ms-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss'],
  animations: [
    trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class IncidentsComponent implements OnInit {

  constructor(
    private navigateService: NavigateService,
     public dialog: MatDialog,
     public cmsService: CmsService,
     public workFlow: WorkFlowService,
     public reportsService: ReportsService
  ) {

  }
  @Input() productDto: ProductDto = null;
  @Input() isLoading: boolean = false;
  @Input() functionalAreasTable: MatTableDataSource<string> = new MatTableDataSource<string>();
  @Input() functionalAreasIncidentsTables: Map<string, MatTableDataSource<PaiIncident>> = new Map<string, MatTableDataSource<PaiIncident>>();
  @Input() expandedElement: string | null;
  @Input() localizedFields: Map<string, string> = new Map<string, string>();

  displayedColumns: string[] = ['area','expand'];
  displayedBugColumns: string[] = ['nr','description'];
  areaToShow: string = "";

  public gravityTexts: BugGravities

  async ngOnInit(): Promise<void> {
  }

  public openIncident(incident: PaiIncident) {
    incident.InquiryRows = this.reportsService.setObjectsEmptyFields<PaiIncidentRow>(incident.InquiryRows);
    this.navigateService.setLocalStorageData('incident', JSON.stringify(incident));
    this.navigateService.setLocalStorageData('productDto', JSON.stringify(this.productDto));
    this.dialog.open(IncidentDetailsComponent);
  }

  public setParameters(row: string) {
    this.expandedElement = this.expandedElement == row ? null : row;
  }

}


